import { getAnalytics } from 'firebase/analytics'
import { FirebaseApp, initializeApp } from 'firebase/app'
import { getPerformance } from "firebase/performance"

export enum FirebaseEnv {
  lab,
  production,
}

const generateConfig = (env: FirebaseEnv) => {
  switch (env) {
    case FirebaseEnv.production:
      return {
        apiKey: 'AIzaSyAjCfubX49axWUfLXWJSnhmgeGPgc3j-Eo',
        authDomain: 'vlive-prod.firebaseapp.com',
        databaseURL: 'https://vlive-prod.firebaseio.com',
        projectId: 'vlive-prod',
        storageBucket: 'vlive-prod.appspot.com',
        messagingSenderId: '165046612228',
        appId: '1:165046612228:web:b3d670285efd2cb301e051',
        measurementId: 'G-ZD9SHCZN8L',
      }
    case FirebaseEnv.lab:
      return {
        apiKey: 'AIzaSyAQJmxgL1t_sL71B_N2FCabFtAwtrDIOLg',
        authDomain: 'vlive-dev.firebaseapp.com',
        databaseURL: 'https://vlive-dev.firebaseio.com',
        projectId: 'vlive-dev',
        storageBucket: 'vlive-dev.appspot.com',
        messagingSenderId: '602877909563',
        appId: '1:602877909563:web:e129c2d37c84addff0da1e',
        measurementId: 'G-VF51KVRKEL',
      }
  }
}

export const initializeFirebaseApp = (env: FirebaseEnv): FirebaseApp =>
  initializeApp(generateConfig(env))

export const firebaseEnv = (): FirebaseEnv => {
  const env = process.env.VUE_APP_VLIVE_ENV
  switch (env) {
    case 'vlive-prod':
      return FirebaseEnv.production
    default:
      return FirebaseEnv.lab
  }
}
export const defaultFirebaseApp = initializeFirebaseApp(firebaseEnv())

export const defaultFirebasePerformance = getPerformance(defaultFirebaseApp)
export const defaultFirebaseAnalytics = getAnalytics(defaultFirebaseApp)
